import { Columns } from '@/types/table';

const LIST_VIEW_COLUMNS: Columns[] = [
  {
    name: 'Address',
    selector: 'propertyAddress',
    type: 'component',
    componentDataType: 'text',
    width: '320px',
    isSortableByHeader: true,
    sticky: 'left'
  },
  {
    name: 'Recent Assets',
    selector: 'recentAssets',
    type: 'component',
    width: '140px',
    isSortableByHeader: false
  },
  // Removed till the time Order implemented

  {
    name: 'Last Order',
    selector: 'lastOrderDate',
    type: 'component',
    componentDataType: 'date',
    width: '140px',
    isSortableByHeader: true
  },
  // {
  //   name: 'Age of photos',
  //   selector: 'age',
  //   type: 'component',
  //   width: '220px'
  // },
  {
    name: 'Unit Status',
    selector: 'propertyStatus',
    type: 'text',
    width: '145px'
  },
  {
    name: 'Rent Ready',
    selector: 'rentReady',
    type: 'text',
    width: '150px'
  },
  {
    name: 'Is Listed',
    selector: 'isListed',
    type: 'text',
    width: '150px'
  },
  {
    name: 'Days on Market',
    selector: 'daysOnMarket',
    type: 'text',
    width: '175px'
  },
  {
    name: 'Assignee',
    selector: 'assignee',
    type: 'text',
    width: '160px'
  },
  {
    name: 'Available Date',
    selector: 'availableDate',
    type: 'date',
    width: '175px'
  },
  {
    name: 'Property Type',
    selector: 'propertyType',
    type: 'text',
    width: '160px'
  },
  {
    name: 'Entity',
    selector: 'entity',
    type: 'text',
    width: '200px'
  },
  {
    name: 'Portfolio',
    selector: 'portfolioName',
    type: 'text',
    width: '160px'
  },
  {
    name: 'Lease Start Date',
    selector: 'leaseStartDate',
    type: 'date',
    width: '178px'
  },
  {
    name: 'Lease End Date',
    selector: 'leaseEndDate',
    type: 'date',
    width: '178px'
  },
  {
    name: 'Notice Given Date',
    selector: 'noticeGivenDate',
    type: 'date',
    width: '196px'
  },
  {
    name: 'Move Out Date',
    selector: 'moveOutDate',
    type: 'date',
    width: '170px'
  },
  {
    name: 'Listing Date',
    selector: 'listingDate',
    type: 'date',
    width: '160px'
  },
  {
    name: 'Property Source',
    selector: 'propertySource',
    type: 'text',
    width: '176px'
  },
  {
    name: 'Is Active',
    selector: 'isActive',
    type: 'text',
    width: '150px'
  },
  {
    name: '',
    selector: 'addToCart',
    type: 'component',
    width: '168px',
    isSortableByHeader: false,
    sticky: 'right'
  }
];

export default LIST_VIEW_COLUMNS;
